import { Box, IconButton, Paper, Slider, Typography } from '@mui/material';
import {
  HEADER_HEIGHT,
  PARTS_SELECTION_CONTENTS_TOP,
} from '../../../_constants/styleConst';
import { useTranslation } from 'react-i18next';
import { PARTS_LIST_IMAGE } from '../../../_constants/Const';
import { Close as CloseIcon } from '@mui/icons-material';
import { useRef, useState } from 'react';
import { PartsListImageType } from '../PartSelection';

type PartsListImageProps = {
  partsListImage?: PartsListImageType;
  setPartsListImage: React.Dispatch<
    React.SetStateAction<PartsListImageType | undefined>
  >;
};

const PartsListImage: React.FC<PartsListImageProps> = ({
  partsListImage,
  setPartsListImage,
}) => {
  const { t } = useTranslation();
  const [isSlider, setIsSlider] = useState<boolean>(false);
  const imageRef = useRef<HTMLImageElement>(null);

  /** パーツリストの画像領域の表示切替 */
  const displayPartsList = (partsListImgInfo?: PartsListImageType) => {
    if (partsListImgInfo) {
      // 読み込み中は領域はそのままで何も表示しない
      if (partsListImgInfo.src === PARTS_LIST_IMAGE.LOADING) {
        if (isSlider) {
          setIsSlider(false);
        }
        return <Box sx={{ width: '100%', height: '100%' }} />;
      }
      // エラーの場合はメッセージ表示
      if (partsListImgInfo.src === PARTS_LIST_IMAGE.ERROR) {
        return (
          <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
            <Typography
              color="red"
              sx={{
                width: '100%',
                textAlign: 'center',
                position: 'absolute',
                top: '50%',
              }}
            >
              {t('ERR_PARTS_LIST_IMAGE')}
            </Typography>
          </Box>
        );
      }
      // 正常に表示する
      if (!isSlider) {
        setIsSlider(true);
      }
      return (
        <Box
          ref={imageRef}
          component="img"
          sx={{
            maxWidth: '100%',
            aspectRatio: 'auto',
            transformOrigin: 'top left',
          }}
          src={partsListImgInfo.src}
        />
      );
    }
  };

  /** 画像領域を閉じる */
  const onClickClose = () => {
    setPartsListImage(undefined);
  };

  /** スライダーで倍率を変更する */
  const onChangedZoom = (_: Event, newValue: number) => {
    if (imageRef.current) {
      imageRef.current.style.transform = `scale(${(newValue * 0.01).toString()})`;
    }
  };

  return (
    <Box
      component={Paper}
      sx={{
        mx: '0.5rem',
        px: '0.5rem',
        minWidth: '38%',
        position: 'sticky',
        display: partsListImage ? 'block' : 'none',
        top: `calc(${HEADER_HEIGHT} + ${PARTS_SELECTION_CONTENTS_TOP})`,
        height: `calc(100dvh - (${HEADER_HEIGHT} + ${PARTS_SELECTION_CONTENTS_TOP} + 1.3rem))`,
      }}
    >
      <Box
        sx={{
          width: '100%',
          position: 'relative',
          height: `calc(100% - 2.5rem)`,
        }}
      >
        <Box sx={{ position: 'absolute', top: '5px' }}>
          <Typography>{partsListImage?.section}</Typography>
        </Box>
        <IconButton
          aria-label="close"
          sx={{ position: 'absolute', right: '-10px', top: '-5px' }}
          onClick={onClickClose}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'auto',
            position: 'absolute',
            top: '2rem',
            bgcolor: '#FFF',
            border: 'solid 1px #e0e0e0',
          }}
        >
          {displayPartsList(partsListImage)}
        </Box>
        <Box
          sx={{
            width: '200px',
            position: 'absolute',
            right: '30px',
            bottom: '-10px',
          }}
        >
          {isSlider && (
            <Slider
              id="partsListImgSlider"
              defaultValue={100}
              step={10}
              valueLabelDisplay="auto"
              min={50}
              max={400}
              onChange={(_, value) => onChangedZoom(_, value)}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default PartsListImage;
